var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":_vm.path}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }